const styles = {
  chatSidebarWrapper: {
    borderRight: '1px solid #DFE2E5',
  },
}
export default styles



// WEBPACK FOOTER //
// ./src/Components/Chat/ChatSidebar/styles.js